// IMPORT PACKAGE REFERENCES
import React, { Fragment } from 'react';
import styles from './CustomListItemText.module.scss'; // Import css modules stylesheet as styles

// COMPONENT
export class CustomListItemText extends React.Component {
    render() {
        const linkStyle =  this.props.onClick ? styles.link : styles.noLink 

        return (
            <div className={styles.primary}>
                <div onClick={this.props.onClick} className={styles.primaryText + " " + linkStyle}>
                    { this.props.primary }
                </div>
                <div className={styles.secondaryText}>
                    { this.props.secondary }
                </div>
            </div>
        );
    }
}